// components/AdminPanel.jsx
import { useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import VideoManager from './admin/VideoManager';
import MusicManager from './admin/MusicManager';
import MembersManager from './admin/MembersManager';
import GalleryManager from './admin/MediaManager';
import PurchasesManager from "./admin/PurchasesManager";
import ContentApprovalManager from './admin/ContentApprovalManager';
import ArtistManagement from './admin/ArtistManagement';
import UsersManager from './admin/UsersManager';
import DashboardView from './admin/DashboardView';

// UPDATED: Accept the currentUser prop
export default function AdminPanel({ 
    db, 
    showToast, 
    videos, 
    music, 
    members, 
    gallery, 
    currentUser // NEW PROP
}) {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'dashboard';

  return (
    <section className="min-h-screen bg-[#0d0d11] mt-20 pb-20">
      <div className="max-w-7xl mx-auto px-4 py-8">

        {/* Tab Content */}
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          {activeTab === 'dashboard' && (
            <DashboardView
              music={music}
              videos={videos}
              members={members}
              gallery={gallery}
            />
          )}

          {/* UPDATED: Pass currentUser to all content managers */}
          {activeTab === 'music' && 
            <MusicManager 
                db={db} 
                showToast={showToast} 
                music={music} 
                currentUser={currentUser} // Passed prop
            />
          }
          {activeTab === 'videos' && 
            <VideoManager 
                db={db} 
                showToast={showToast} 
                videos={videos} 
                currentUser={currentUser} // Passed prop
            />
          }
          {activeTab === 'members' && 
            <MembersManager 
                db={db} 
                showToast={showToast} 
                members={members} 
                currentUser={currentUser} // Passed prop
            />
          }
          {activeTab === 'users' && 
            <UsersManager 
                db={db} 
                showToast={showToast} 
            />
          }
          {activeTab === 'gallery' && 
            <GalleryManager 
                db={db} 
                showToast={showToast} 
                gallery={gallery} 
                currentUser={currentUser} // Passed prop
            />
          }
          {activeTab === 'purchases' && (
            <PurchasesManager 
                db={db} 
                showToast={showToast} 
                // Note: PurchasesManager usually doesn't need currentUser, 
                // but you can pass it if you want to track who views the purchases.
            />
          )}
          {activeTab === 'approving' && (
            <ContentApprovalManager 
                db={db} 
                showToast={showToast} 
                currentUser={currentUser}
            />
          )}
          {activeTab === 'artist-management' && (
            <ArtistManagement 
                db={db} 
                showToast={showToast}
            />
          )}

        </motion.div>
      </div>
    </section>
  );
}